import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { BaseHttpService } from '../../../shared/services/base-http.service';
import { CONTROLLER_CONSTANTS } from '../../../shared/constants/controller.constants';
import { ENDPOINT_CONSTANTS } from '../../../shared/constants/endpoint.constants';
import {
  DocumentUploadRequest,
  DocumentUploadResponse,
  ChunkUploadRequest,
  ChunkUploadResponse
} from '../interfaces/document.interface';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  constructor(private baseHttp: BaseHttpService) {}

  uploadDocument(request: DocumentUploadRequest): Observable<DocumentUploadResponse> {
    const formData = new FormData();
    formData.append('File', request.file);
    formData.append('CollectionName', request.collectionName);
    formData.append('DocumentName', request.documentName);
    formData.append('Category', request.category);
    formData.append('Extension', request.extension);

    const endpoint = `/${CONTROLLER_CONSTANTS.DOCUMENT}/${ENDPOINT_CONSTANTS.UPLOAD_DOCUMENT}`;
    return this.baseHttp.postFile<DocumentUploadResponse>(endpoint, formData);
  }

  downloadDocument(collectionName: any, documentName: any, preview = false) {
    const endpoint = `/${CONTROLLER_CONSTANTS.DOCUMENT}/${ENDPOINT_CONSTANTS.DOWNLOAD_DOCUMENT}`;
    const params = {
      collectionName: collectionName,
      documentName: documentName,
      preview: preview
    };
    return this.baseHttp.getBlobWithResponse(endpoint, params);
  }
  uploadChunk(request: ChunkUploadRequest): Observable<ChunkUploadResponse> {
    const body = {
      chunkName: request.chunkName,
      chunkDescription: request.chunkDescription,
      collectionName: request.collectionName
    };

    const endpoint = `/${CONTROLLER_CONSTANTS.DOCUMENT}/${ENDPOINT_CONSTANTS.UPLOAD_CHUNK}`;
    return this.baseHttp.post<ChunkUploadResponse>(endpoint, body);
  }

  getSecureImageBlob(imageUrl: string): Observable<Blob> {
    const endpoint = `/${CONTROLLER_CONSTANTS.DOCUMENT}/secure-image`;

    return this.baseHttp.getBlobWithResponse(endpoint, { imageUrl }).pipe(
      map((response) => {
        if (!response.body) {
          throw new Error('Secure image response did not contain a file stream.');
        }

        return response.body;
      })
    );
  }
}